import { VStack } from "@gluestack-ui/themed";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { PersonalDataFormController } from "@repo/core/screens/ProposalEffectiveFlows/Credit/PersonalDataForm/controller";
import { Text } from "@repo/core/components/core/Text";
import { SelectControlled } from "@repo/core/components/forms/SelectControlled";
import { InputTypeSelectControlled } from "@repo/core/components/forms/InputTypeSelect";
import { inputTypeOptions } from "@repo/core/screens/ProposalEffectiveFlows/Credit/PersonalDataForm/utils";
import { ProgressBar } from "@repo/core/components/layout/ProgressBar";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";
import {
  PARENT_NAME_MAX_LENGTH,
  limitParentName
} from "@repo/core/utils/parentName.utils";

const PersonalDataForm = () => {
  const {
    control,
    handleOnSubmitForm,
    handleGoBack,
    handleClose,
    martialStatusOptions,
    isLoadingProposal
  } = PersonalDataFormController();

  return (
    <PageScaffold
      onBackPress={handleGoBack}
      showBackButtonOnWeb
      onPressRightIcon={handleClose}
      rightWebLabel="Fechar"
      title="Proposta de Crédito"
      isLoading={isLoadingProposal}
      loadingTitle="Carregando dados da proposta"
      loadingDescription="Aguarde enquanto buscamos as informações..."
      footerContent={
        !isLoadingProposal ? (
          <ScaffoldFooter
            primaryText="Continuar"
            primaryAction="primary"
            primaryOnPress={handleOnSubmitForm}
          />
        ) : undefined
      }
    >
      <VStack w="$full" gap="$4" pb="$4">
        <ProgressBar progress={20} />
        <Text>Dados pessoais adicionais:</Text>

        <InputControlled
          control={control}
          isRequired
          keyboardType="number-pad"
          label="Data de Nascimento"
          mask="date"
          name="birthday"
          placeholder="dd/mm/aaaa"
          useMaskValue
          enterKeyHint="done"
        />

        <InputTypeSelectControlled
          control={control}
          inputTypes={inputTypeOptions}
          label="Gênero"
          name="gender"
          isRequired
        />

        <SelectControlled
          control={control}
          isRequired
          label="Estado civil"
          name="martialStatus"
          options={martialStatusOptions}
          placeholder="Selecione o estado civil"
        />

        <InputControlled
          control={control}
          isRequired
          label="Nome da Mãe"
          name="mothersName"
          placeholder="Digite o nome e o sobrenome da mãe"
          maxLength={PARENT_NAME_MAX_LENGTH}
          transformValue={limitParentName}
        />

        <InputControlled
          control={control}
          isRequired
          label="Número do documento"
          name="documentNumber"
          placeholder="Número do documento (Apenas números)"
          keyboardType="number-pad"
        />
      </VStack>
    </PageScaffold>
  );
};

export default PersonalDataForm;
